
import React, {Component, Fragment} from 'react'
import {Modal, ModalBody} from 'reactstrap';
import Floor from '../../components/floor/Floor'
import SaleDetailView from "../../components/sale/SaleDetailView";


class FloorOverview extends Component 
{
    constructor(props)
    {
        super(props);
        this.onStencilClick = this.onStencilClick.bind(this);

        this.state = {};

        this.state.displaySaleDetailsDialogue = false;
        this.state.displaySale = null;
    }


    render()
    {
        return <Fragment>
                    <Floor onStencilClick={this.onStencilClick}/>
                    {this.renderSaleDetails()}
               </Fragment>
    }

    onStencilClick(stencil, primarySale, mergedSale)
    {
        this.state.displaySale = primarySale ?? mergedSale;
        if (this.state.displaySale != null)
        {
            this.state.displaySaleDetailsDialogue = true;
            this.setState({});
        }
    }

    renderSaleDetails()
    {
        if (!this.state.displaySaleDetailsDialogue || this.state.displaySale == null)
            return;

        return(<Modal   isOpen={true} centered animation={false} fade={false} style={{minWidth:'30vw', maxWidth:'30vw'}}
                        toggle={()=>
                        {
                            this.state.displaySaleDetailsDialogue = false;
                            this.state.displaySale = null;
                            this.setState({});
                        }} >
                    <ModalBody>
                        <div>
                            <div style={{maxHeight:'80vh', overflowY:'auto'}}>
                                <SaleDetailView sale={this.state.displaySale} 
                                                onDispatch={()=>
                                                    {
                                                        this.state.displaySaleDetailsDialogue = false;
                                                        this.state.displaySale = null;
                                                        this.setState({});
                                                    }}/>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>);
    }

}

export default FloorOverview